module.exports = __webpack_public_path__ + "static/media/silkycloud-black-1.1ba4c9e6.png";